<template>
    <div
        id="easypack-map"
        v-inpost
    />
</template>

<script>
export default {
    props: {
        value: String,
    },
    directives: {
        inpost: {
            inserted(el, binding, vNode) {
                easyPack.init({});
                var map = easyPack.mapWidget('easypack-map', function(point){
                    vNode.context.$emit("select-point", point);
                });
            }
        }
    }
};
</script>